import { ReactNode } from 'react';
import Container from './container';

export default function NavigationItemContainer({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Container extensions="px-5 py-[1.35rem] border-b border-dark-gray w-full">
      {children}
    </Container>
  );
}
